import axios from '../axios/axios';
import {
  FOREIGN_RESIDENCY_DATA_REQUEST,
  FOREIGN_RESIDENCY_DATA_SUCCESS,
  FOREIGN_RESIDENCY_DATA_FAIL,
} from '../constants/foreignResidencyConstants';

export const foreignResidencyAction = () => async (dispatch) => {
  try {
    dispatch({ type: FOREIGN_RESIDENCY_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s17',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: FOREIGN_RESIDENCY_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: FOREIGN_RESIDENCY_DATA_FAIL,
      payload: error,
    });
  }
};
